export const PrivacyPolicy = () => {
  return (
    <div className="mx-auto max-w-3xl px-6 py-16" data-testid="privacy-page">
      <h1 className="mb-2 font-heading text-4xl font-bold text-white">Privacy Policy</h1>
      <p className="mb-10 text-sm text-slate-500">Last updated: September 2026</p>

      <div className="space-y-8 text-slate-300">
        <section>
          <h2 className="mb-2 font-heading text-lg font-bold text-sovereign">1. Information We Collect</h2>
          <ul className="list-disc space-y-1 pl-5">
            <li>Account data: email address, name, and a hashed password.</li>
            <li>Audit data: brand names you submit, the AI-generated results (scores, warnings, competitor
              mentions), and any URL/PDF you upload for Truth Verification.</li>
            <li>Payment data: handled entirely by Stripe. We never see or store your card number.</li>
            <li>Support data: any message you submit via the Support &amp; Feedback portal.</li>
            <li>Chat data: your conversation history with BrandSignal Buddy, stored to keep context across sessions.</li>
            <li>Technical data: IP address (for rate-limiting/abuse prevention) and session cookies.</li>
          </ul>
        </section>

        <section>
          <h2 className="mb-2 font-heading text-lg font-bold text-sovereign">2. How We Use Your Information</h2>
          <p>
            We use your data to operate the Service: running AI brand audits, generating reports, processing
            payments, sending transactional emails (password resets, signal alerts, digests, invites), responding
            to support requests, and powering BrandSignal Buddy.
          </p>
        </section>

        <section>
          <h2 className="mb-2 font-heading text-lg font-bold text-sovereign">3. Third-Party Processors</h2>
          <p>
            To generate a report, the brand name and audit context you submit are sent to OpenAI, Anthropic,
            Google, and Perplexity. Payments are processed by Stripe. Transactional email is sent via Google/Gmail.
            Each of these providers processes data under its own privacy terms.
          </p>
        </section>

        <section>
          <h2 className="mb-2 font-heading text-lg font-bold text-sovereign">4. Cookies &amp; Sessions</h2>
          <p>
            We use httpOnly session cookies solely to keep you signed in. We do not use third-party advertising
            cookies.
          </p>
        </section>

        <section>
          <h2 className="mb-2 font-heading text-lg font-bold text-sovereign">5. Data Retention</h2>
          <p>
            We retain account and audit data for as long as your account is active, or as needed to provide the
            Service and comply with legal obligations. You may request deletion at any time.
          </p>
        </section>

        <section>
          <h2 className="mb-2 font-heading text-lg font-bold text-sovereign">6. Your Rights</h2>
          <p>
            You may request access to, correction of, or deletion of your personal data by contacting us through
            the <a href="/support" className="text-openai-cyan hover:underline">Support &amp; Feedback</a> portal.
          </p>
        </section>

        <section>
          <h2 className="mb-2 font-heading text-lg font-bold text-sovereign">7. Children's Privacy</h2>
          <p>The Service is not directed to individuals under 16, and we do not knowingly collect their data.</p>
        </section>

        <section>
          <h2 className="mb-2 font-heading text-lg font-bold text-sovereign">8. No Warranty &amp; Limitation of Liability</h2>
          <p>
            Personal data is processed to power AI-generated reports and the BrandSignal Buddy assistant "as is,"
            without warranty of accuracy. BrandSignal is not liable for decisions made in reliance on data
            processed under this policy. See our <a href="/ai-transparency" className="text-openai-cyan hover:underline">AI
            Transparency Disclosure</a> and <a href="/terms" className="text-openai-cyan hover:underline">Terms of
            Service</a> for the full disclaimer and liability limitation.
          </p>
        </section>

        <section>
          <h2 className="mb-2 font-heading text-lg font-bold text-sovereign">9. Changes to This Policy</h2>
          <p>We may update this Privacy Policy from time to time; the "Last updated" date above will reflect the latest revision.</p>
        </section>

        <section>
          <h2 className="mb-2 font-heading text-lg font-bold text-sovereign">10. Contact</h2>
          <p>
            Privacy questions or data requests can be sent via our
            <a href="/support" className="text-openai-cyan hover:underline"> Support &amp; Feedback</a> portal.
          </p>
        </section>
      </div>
    </div>
  );
};
